export { Logos, logos_list } from './Logos';
